const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.891,26.476c-0.042,-1.228 -0.185,-2.463 -0.4,-3.671c-0.26,-1.466 -0.59,-3.613 -1.869,-4.568c-0.74,-0.552 -1.698,-0.733 -2.545,-1.066c-0.412,-0.162 -0.781,-0.323 -1.127,-0.506c-1.17,1.283 -2.695,1.954 -4.471,1.954c-1.775,0 -3.3,-0.671 -4.47,-1.954c-0.346,0.183 -0.715,0.344 -1.127,0.506c-0.847,0.333 -1.805,0.514 -2.545,1.066c-1.279,0.955 -1.609,3.102 -1.869,4.568c-0.215,1.208 -0.358,2.443 -0.401,3.671c-0.032,0.952 0.438,1.085 1.234,1.372c0.996,0.36 2.025,0.626 3.061,0.845c2.001,0.423 4.064,0.748 6.117,0.763c2.054,-0.015 4.116,-0.34 6.117,-0.763c1.036,-0.218 2.065,-0.485 3.062,-0.845c0.796,-0.287 1.266,-0.42 1.233,-1.372Zm-10.411,-9.176c3.849,0 5.233,-3.855 5.596,-7.02c0.447,-3.9 -1.397,-6.835 -5.596,-6.835c-4.199,0 -6.044,2.935 -5.597,6.835c0.363,3.165 1.747,7.02 5.597,7.02Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e8630ffe81b3124fba027d6ab33bcb94.svg";
export { ForwardRef as ReactComponent };